//header fixed
$(".wd-product-page-header-handle").click(function () {
  if ($(this).hasClass("wd-product-page-header-handle-active")) {
    $(this).removeClass("wd-product-page-header-handle-active");
    $(this).addClass("wd-product-page-header-handle-active2");
    $(this).siblings(".wd-product-page-header-handle-menu").slideUp();
  } else {
    $(this).removeClass("wd-product-page-header-handle-active2");
    $(this).addClass("wd-product-page-header-handle-active");
    $(this).siblings(".wd-product-page-header-handle-menu").slideDown();
  }
});
$(document).scroll(function () {
  var scroH = $(document).scrollTop();
  var header = $(".wd-product-page-content").offset().top;
  if (scroH >= header) {
    $(".wd-product-page-header").css("position", "fixed");
    $(".wd-product-page-header").css("z-index", "3");
  } else {
    $(".wd-product-page-header").css("position", "absolute");
    $(".wd-product-page-header").css("z-index", "1");
  }
});

//banner video show
$(".wd-product-page-banner-video").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "https://www.youtube.com/embed/dGlfk1kYvos");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show")
    .fadeIn(200);
  $(this).parents("html").css("overflow", "hidden");
});

$(".wd-product-page-videos-item")
  .eq(0)
  .click(function () {
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show iframe")
      .prop("src", "https://www.youtube.com/embed/QJahCaKNAUs");
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show")
      .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
  });

$(".wd-product-page-videos-item")
  .eq(1)
  .click(function () {
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show iframe")
      .prop("src", "https://www.youtube.com/embed/dGlfk1kYvos");
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show")
      .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
  });
  $(".wd-product-page-videos-item")
  .eq(2)
  .click(function () {
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show iframe")
      .prop("src", "https://www.youtube.com/embed/qMq45_bwSU8");
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show")
      .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
  });
$(".wd-product-page-videos-item")
  .eq(3)
  .click(function () {
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show iframe")
      .prop("src", "https://www.youtube.com/embed/TruGKoHmDzs");
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-banner-video-show")
      .fadeIn(200);
    $(this).parents("html").css("overflow", "hidden");
  });

$(".wd-product-page-banner-video-show-btn").click(function () {
  $(this).parents(".wd-product-page-banner-video-show").fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
});
$(".wd-product-page-banner-video-show").click(function () {
  $(this).fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-banner-video-show iframe")
    .prop("src", "");
  $(this).parents("html").css("overflow", "auto");
});
$('.wd-product-page-videos-item-share a').click(function(event) {
  event.stopPropagation();
});

//click choose card
$(".wd-product-page-header-title").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeIn();

  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeOut(200);

  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-spe").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeOut(200);

  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);

  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-faq").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeOut(200);

  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

$(".wd-product-page-header-videos").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);

  $("html").animate({ scrollTop: 0 }, 0);
});
$(".wd-product-page-header-handle-menu-videos").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-videos")
    .fadeIn(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-overview")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-spec")
    .fadeOut(200);
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-faq")
    .fadeOut(200);

  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle-menu")
    .slideUp();
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .removeClass("wd-product-page-header-handle-active");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-header-handle")
    .addClass("wd-product-page-header-handle-active2");
  $("html").animate({ scrollTop: 0 }, 0);
});

//faq click show
$(".wd-product-page-faq-content-q").click(function () {
  if (
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display") == "none"
  ) {
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-minus")
      .css("display", "none");
    $(this)
      .parents(".wd-product-page-faq-content")
      .siblings(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-q-add")
      .css("display", "block");

    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideDown();
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .css("display", "flex");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(1)
      .css("display", "block");
  } else {
    $(this)
      .parents(".wd-product-page-faq-content")
      .find(".wd-product-page-faq-content-a")
      .slideUp();
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .css("display", "none");
    $(this)
      .find(".wd-product-page-faq-content-q-svg svg")
      .eq(0)
      .css("display", "block");
  }
});

//deep filtration btn
$(".wd-product-page-hover-btn").mouseenter(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-enter 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});
$(".wd-product-page-hover-btn").mouseleave(function () {
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation",
    "animation-top-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation",
    "animation-bottom-leave 0.5s"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-top").css(
    "animation-fill-mode",
    "forwards"
  );
  $(".wd-product-page-hover-btn-icon-semicircle-bottom").css(
    "animation-fill-mode",
    "forwards"
  );
});

//scene change
var index = 0;
var images = [
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-img1.jpg?v=1678329552",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-img2.jpg?v=1678329552",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-img3.jpg?v=1678329552",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-img4.jpg?v=1678329552",
];
var images1 = [
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-4mode-img1.png?v=1678180020",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-4mode-img2.png?v=1678180020",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-4mode-img3.png?v=1678180020",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-k19-4mode-img4.png?v=1678180020",
];
var images2 = [
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img1-new.png?v=1678696951",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img2-new.png?v=1678696951",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img3-new.png?v=1678692542",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img4-new.png?v=1678692542",
];
var images3 = [
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img1-new1.png?v=1678699422",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img2-new2.jpg?v=1678699422",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img3-new3.png?v=1678699422",
  "https://cdn.shopify.com/s/files/1/0078/6156/7570/files/wd-product-page-scene-new-mobile-img4-new4.png?v=1678699422",
];
for (var i = 0; i < images.length; i++) {
  var image = new Image();
  image.src = images[i];
}
for (var i = 0; i < images1.length; i++) {
  var image = new Image();
  image.src = images1[i];
}
for (var i = 0; i < images2.length; i++) {
  var image = new Image();
  image.src = images2[i];
}
for (var i = 0; i < images3.length; i++) {
  var image = new Image();
  image.src = images3[i];
}
var window_width = $(window).width();
if(window_width <= 767){
  setInterval(function () {
    index = (index + 1) % images3.length;
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images3[index] + "')"
    );
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .siblings()
      .removeClass("wd-product-page-scene-content-item-active");
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .addClass("wd-product-page-scene-content-item-active");
  }, 5000);

  $(".wd-product-page-scene-content-item").click(function () {
    index = $(this).index();
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images3[index] + "')"
    );
    $(this).addClass("wd-product-page-scene-content-item-active");
    $(this).siblings().removeClass("wd-product-page-scene-content-item-active");
  });
}
else if (window_width <= 1024) {
  setInterval(function () {
    index = (index + 1) % images2.length;
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images2[index] + "')"
    );
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .siblings()
      .removeClass("wd-product-page-scene-content-item-active");
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .addClass("wd-product-page-scene-content-item-active");
  }, 5000);
  $(".wd-product-page-scene-content-item").click(function () {
    index = $(this).index();
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images2[index] + "')"
    );
    $(this).addClass("wd-product-page-scene-content-item-active");
    $(this).siblings().removeClass("wd-product-page-scene-content-item-active");
  });
 
} else {
  setInterval(function () {
    index = (index + 1) % images.length;
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images[index] + "')"
    );
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .siblings()
      .removeClass("wd-product-page-scene-content-item-active");
    $(".wd-product-page-scene-content-item")
      .eq(index)
      .addClass("wd-product-page-scene-content-item-active");
  }, 5000);
  $(".wd-product-page-scene-content-item").click(function () {
    index = $(this).index();
    $(".wd-product-page-scene").css(
      "background-image",
      "url('" + images[index] + "')"
    );
    $(this).addClass("wd-product-page-scene-content-item-active");
    $(this).siblings().removeClass("wd-product-page-scene-content-item-active");
  });
  
}
// Smart Display choose card
$(".wd-product-page-blocks-item-content-choose-item").click(function () {
  var index = $(this).index();

  $(this).addClass("wd-product-page-blocks-item-content-choose-item-active");
  $(this)
    .siblings()
    .removeClass("wd-product-page-blocks-item-content-choose-item-active");

  $(this)
    .parents(".wd-product-page-blocks-item")
    .find(".wd-product-page-blocks-item-media video")
    .eq(index)
    .siblings()
    .css("display", "none");
  $(this)
    .parents(".wd-product-page-blocks-item")
    .find(".wd-product-page-blocks-item-media video")
    .eq(index)
    .css("display", "block");
});

// 4-stage Deep Filtration click popup
$(".wd-product-page-deep-filtration .wd-product-page-hover-btn").click(
  function () {
    $(this).parents("html").css("overflow", "hidden");
    $(this)
      .parents(".wd-product-page-content")
      .find(".wd-product-page-animation-filtration")
      .css({ top: "0" });
  }
);
$(".wd-product-page-animation-filtration-content-close").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-animation-filtration")
    .css({ top: "100vh" });
  $(this).parents("html").css("overflow", "auto");
});

// V-heating Technology click popup
var swiperindex;
var mode_4_swiper = new Swiper(
  ".wd-product-page-animation-technology-content-4mode-img-swiper",
  {
    direction: "vertical",
    mousewheel: {
      releaseOnEdges: true,
      sensitivity: 0.9,
    },
    on: {
      slideChangeTransitionEnd: function () {
        if (this.activeIndex == 0) {
          $(
            ".wd-product-page-animation-technology-content-4mode-choose-item"
          ).removeClass(
            "wd-product-page-animation-technology-content-4mode-choose-item-active"
          );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(0)
            .addClass(
              "wd-product-page-animation-technology-content-4mode-choose-item-active"
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(0)
            .siblings()
            .animate(
              {
                height: "30px",
              },
              300
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(0)
            .animate(
              {
                height: "58px",
              },
              300
            );
        } else if (this.activeIndex == 1) {
          $(
            ".wd-product-page-animation-technology-content-4mode-choose-item"
          ).removeClass(
            "wd-product-page-animation-technology-content-4mode-choose-item-active"
          );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(1)
            .addClass(
              "wd-product-page-animation-technology-content-4mode-choose-item-active"
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(1)
            .siblings()
            .animate(
              {
                height: "30px",
              },
              300
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(1)
            .animate(
              {
                height: "58px",
              },
              300
            );
        } else if (this.activeIndex == 2) {
          $(
            ".wd-product-page-animation-technology-content-4mode-choose-item"
          ).removeClass(
            "wd-product-page-animation-technology-content-4mode-choose-item-active"
          );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(2)
            .addClass(
              "wd-product-page-animation-technology-content-4mode-choose-item-active"
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(2)
            .siblings()
            .animate(
              {
                height: "30px",
              },
              300
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(2)
            .animate(
              {
                height: "58px",
              },
              300
            );
        } else if (this.activeIndex == 3) {
          $(
            ".wd-product-page-animation-technology-content-4mode-choose-item"
          ).removeClass(
            "wd-product-page-animation-technology-content-4mode-choose-item-active"
          );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(3)
            .addClass(
              "wd-product-page-animation-technology-content-4mode-choose-item-active"
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(3)
            .siblings()
            .animate(
              {
                height: "30px",
              },
              300
            );
          $(".wd-product-page-animation-technology-content-4mode-choose-item")
            .eq(3)
            .animate(
              {
                height: "58px",
              },
              300
            );
        }
        swiperindex = this.activeIndex;
      },
    },
  }
);
$(".wd-product-page-animation-technology-content-4mode-choose-item").click(
  function () {
    mode_4_swiper.slideTo($(this).index(), 500, false);
    $(".wd-product-page-animation-technology-content-4mode-choose-item")
      .eq($(this).index())
      .siblings()
      .removeClass(
        "wd-product-page-animation-technology-content-4mode-choose-item-active"
      );
    $(".wd-product-page-animation-technology-content-4mode-choose-item")
      .eq($(this).index())
      .addClass(
        "wd-product-page-animation-technology-content-4mode-choose-item-active"
      );
    $(this)
      .siblings(
        ".wd-product-page-animation-technology-content-4mode-choose-item"
      )
      .animate(
        {
          height: "30px",
        },
        300
      );
    $(this).animate(
      {
        height: "58px",
      },
      300
    );
  }
);

$(".wd-product-page-technology .wd-product-page-hover-btn").click(function () {
  $(this).parents("html").css("overflow", "hidden");
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-animation-technology")
    .css({ top: "0" });
});
$(".wd-product-page-animation-technology-content-close").click(function () {
  $(this)
    .parents(".wd-product-page-content")
    .find(".wd-product-page-animation-technology")
    .css({ top: "100vh" });
  $(this).parents("html").css("overflow", "auto");
});

// V-heating Technology popup animation
var window_width = $(window).width();
$(".wd-product-page-animation-technology-content").scroll(function () {
  var scroH = $(".wd-product-page-animation-technology-content-4mode").height();
  var scroH2 = $(
    ".wd-product-page-animation-technology-content-4mode"
  ).height();
  var scrollTop = $(
    ".wd-product-page-animation-technology-content"
  ).scrollTop();
  if (window_width >= 768) {
    if (scrollTop >= scroH) {
      $(".wd-product-page-animation-technology-content-5mode-imgs").addClass(
        "wd-product-page-animation-technology-content-5mode-imgs-active"
      );
    }
  } else {
    if (scrollTop > scroH2 - 100) {
      $(".wd-product-page-animation-technology-content-5mode-imgs").addClass(
        "wd-product-page-animation-technology-content-5mode-imgs-active"
      );
    }
  }
});

$(".wd-product-page-animation-filtration-content").scroll(function () {
  var scrollTop = $(
    ".wd-product-page-animation-filtration-content"
  ).scrollTop();
  if (scrollTop >= 10) {
    $(".wd-index-mouse-scroll").css("opacity", "0");
  } else {
    $(".wd-index-mouse-scroll").css("opacity", "1");
  }
});

$(".wd-product-page-animation-technology-content").scroll(function () {
  var scrollTop = $(
    ".wd-product-page-animation-technology-content"
  ).scrollTop();
  if (scrollTop >= 10) {
    $(".wd-index-mouse-scroll").css("opacity", "0");
  } else {
    $(".wd-index-mouse-scroll").css("opacity", "1");
  }
});

var swiper = new Swiper(".wd-product-page-des-mobile-swiper", {
  navigation: {
    nextEl: ".wd-product-page-des-mobile-swiper-button-next",
    prevEl: ".wd-product-page-des-mobile-swiper-button-prev",
  },

  loop: true,
  pagination: {
    el: ".wd-product-page-des-mobile-swiper-pagination",
  },
  mousewheel: true,
  keyboard: true,
});

var swiper1 = new Swiper(
  ".wd-product-page-animation-technology-content-4mode-mobile-swiper",
  {
    slidesPerView: "auto",
    spaceBetween: 16,
    centeredSlides: true,
    navigation: {
      nextEl:
        ".wd-product-page-animation-technology-content-4mode-mobile-swiper-button-next",
      prevEl:
        ".wd-product-page-animation-technology-content-4mode-mobile-swiper-button-prev",
    },
    pagination: {
      el: ".wd-product-page-animation-technology-content-4mode-mobile-swiper-pagination",
      clickable: true,
    },
  }
);

let tl_banner = gsap.timeline({
  scrollTrigger: {
    trigger: ".wd-product-page-des-pc",
    y: () => {
      innerHeight;
    },
    // pin: true,
    start: "top 80%",
    end: "+=1000",
    scrub: 0,
  },
});

tl_banner
  .to(
    ".wd-product-page-des-item1",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
  )
  .to(
    ".wd-product-page-des-item2",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    0.4
  )
  .to(
    ".wd-product-page-des-item3",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    0.6
  )
  .to(
    ".wd-product-page-des-item4",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    0.8
  )
  .to(
    ".wd-product-page-des-item5",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    1.0
  )
  .to(
    ".wd-product-page-des-item6",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    1.2
  )
  .to(
    ".wd-product-page-des-item7",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    1.4
  )
  .to(
    ".wd-product-page-des-item8",
    {
      y: "0",
      autoAlpha: "1",
      duration: "0.5",
    },
    1.6
  );
